export default __webpack_public_path__ + "static/media/instagram 1.d1955e8b.svg";